import styled from 'styled-components';

import { media } from '@theme/mixins';
import colors from '@theme/colors';

export const FormWrap = styled.div`
  &.ltr {
    .honey {
      left: -5000px;
    }
  }
  &.rtl {
    .honey {
      left: 5000px;
    }
  }
`;

export const Form = styled.form``;

export const ConfirmTitle = styled.h3`
  font-size: 24px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.42;
  letter-spacing: -0.32px;
  color: ${colors['very-light-brown']};
  margin-bottom: 24px;
`;

export const ConfirmMessage = styled.p`
  font-size: 16px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.44;
  letter-spacing: -0.32px;
  color: ${colors['white']};
`;
